export const REQUEST = "/api/addresses/addresses/-REQUEST";
export const SUCCESS = "/api/addresses/addresses/-SUCCESS";
export const FAILURE = "/api/addresses/addresses/-FAILURE";


// WEBPACK FOOTER //
// ./src/ducks/addresses/constants.js